/*
 * Compagnons de Cœur — partage du choix de consentement entre la boutique et l'atelier.
 *
 * La bannière native de la boutique range le choix dans des cookies propres à compagnonsdecoeur.fr,
 * que l'atelier (portrait-animaux.compagnonsdecoeur.fr) ne reçoit pas. Ce script publie chaque choix
 * explicite dans un cookie miroir `cdc_consent_v1` du domaine racine ; l'atelier l'importe dans sa
 * propre bannière Shopify, qui écrit alors `_tracking_consent` au format natif, relu par la boutique.
 *
 * La boutique n'écrit jamais `_tracking_consent` elle-même : la valeur produite par l'API en mode headless
 * ne porte pas la région, et la boutique traitait alors un refus comme un accord (pixels actifs, mesuré le
 * 02/10/2026). Elle supprime seulement un `_tracking_consent` racine périmé quand le visiteur change d'avis
 * ici. L'état « aucun choix » n'est jamais publié.
 *
 * Source : dépôt portrait-animaux, shopify/assets/cdc-consent-share.js.
 */
(function () {
  'use strict';
  if (window.CDCConsentShare) return;
  var ROOT = 'compagnonsdecoeur.fr';
  var MIRROR = 'cdc_consent_v1';
  var host = location.hostname;
  if (host !== ROOT && host.slice(-ROOT.length - 1) !== '.' + ROOT) return;

  function readCookie(name) {
    var part = document.cookie.split('; ').filter(function (p) { return p.indexOf(name + '=') === 0; })[0];
    return part ? part.slice(name.length + 1) : '';
  }

  function readMirror() {
    var match = /^a=([01])&m=([01])&p=([01])&t=(\d+)$/.exec(readCookie(MIRROR));
    return match ? { analytics: match[1] === '1', marketing: match[2] === '1', preferences: match[3] === '1' } : null;
  }

  function writeMirror(choice) {
    var value = 'a=' + (choice.analytics ? 1 : 0) + '&m=' + (choice.marketing ? 1 : 0) + '&p=' + (choice.preferences ? 1 : 0) + '&t=' + Date.now();
    document.cookie = MIRROR + '=' + value + '; path=/; domain=' + ROOT + '; max-age=31536000; SameSite=Lax; Secure';
  }

  function same(a, b) {
    return !!a && !!b && a.analytics === b.analytics && a.marketing === b.marketing && a.preferences === b.preferences;
  }

  // Choix exprimé sur la boutique (bandeau ou panneau des préférences).
  document.addEventListener('visitorConsentCollected', function (event) {
    var detail = (event && event.detail) || {};
    // `_tracking_consent` racine vient de l'atelier : il primerait sur ce nouveau choix, on le retire.
    document.cookie = '_tracking_consent=; Max-Age=0; path=/; domain=' + ROOT;
    writeMirror({ analytics: !!detail.analyticsAllowed, marketing: !!detail.marketingAllowed, preferences: !!detail.preferencesAllowed });
  });

  // Choix déjà stocké par la boutique (y compris avant ce script) mais pas encore publié.
  function publishStoredChoice() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.currentVisitorConsent !== 'function') return;
    var consent = privacy.currentVisitorConsent() || {};
    var answered = function (value) { return value === 'yes' || value === 'no'; };
    if (!answered(consent.analytics) || !answered(consent.marketing)) return;
    var choice = { analytics: consent.analytics === 'yes', marketing: consent.marketing === 'yes', preferences: consent.preferences === 'yes' };
    if (!same(choice, readMirror())) writeMirror(choice);
  }

  // Lien « Préférences de confidentialité » du pied de page : rouvre le panneau natif de Shopify.
  document.addEventListener('click', function (event) {
    var target = event.target;
    var link = target && target.closest ? target.closest('[data-cdc-privacy-preferences]') : null;
    if (!link) return;
    event.preventDefault();
    // Depuis le 15/10/2026, le bandeau de Shopify laisse le focus sur un repère invisible
    // (#shopify-pc__banner__focus-target) qui se retire lui-même quand il perd le focus. showPreferences()
    // le retire aussi : le second retrait échoue (NotFoundError) et le panneau ne s'ouvre pas. Cela arrive
    // quand le clic ne déplace pas le focus (Safari, clic par script). On le retire avant d'ouvrir le panneau.
    var focusTarget = document.getElementById('shopify-pc__banner__focus-target');
    if (focusTarget) {
      if (document.activeElement === focusTarget) focusTarget.blur();
      if (focusTarget.parentNode) focusTarget.parentNode.removeChild(focusTarget);
    }
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') window.privacyBanner.showPreferences();
  });

  if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.currentVisitorConsent === 'function') publishStoredChoice();
  else if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { if (!error) publishStoredChoice(); });
  }
  window.CDCConsentShare = { readMirror: readMirror };
})();
